import { SelectFields } from '@repo/toolkit/types'

import { EnrollmentIdentity } from '../../models/enrollment/enrollment-identity'
import { FieldsSelector } from '../../utils'

export const enrollmentIdentityBaseFields = [
  'id',
  'identityDocumentExpiration',
  'identityDocumentIssuedAt',
  'identityDocumentIssuingCountry',
  'identityDocumentNumber',
  'identityDocumentType'
] as const satisfies FieldsSelector<EnrollmentIdentity>

export type EnrollmentIdentityBase = SelectFields<
  EnrollmentIdentity,
  typeof enrollmentIdentityBaseFields
>
